var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevrondoublearrowup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 4,
    viewBox: "0 0 3 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.073273 3.90991C0.0263563 3.85221 0 3.77395 0 3.69236C0 3.61077 0.0263563 3.53252 0.073273 3.47482L1.32458 1.93631C1.37151 1.87862 1.43515 1.84621 1.50151 1.84621C1.56787 1.84621 1.63151 1.87862 1.67845 1.93631L2.92975 3.47482C2.97534 3.53285 3.00056 3.61058 2.99999 3.69126C2.99942 3.77193 2.9731 3.84911 2.9267 3.90616C2.8803 3.96321 2.81753 3.99557 2.75191 3.99627C2.6863 3.99697 2.62308 3.96596 2.57588 3.90991L1.50151 2.58894L0.427142 3.90991C0.380211 3.96759 0.316567 4 0.250207 4C0.183847 4 0.120204 3.96759 0.073273 3.90991ZM0.073273 2.06369C0.0263563 2.00599 0 1.92774 0 1.84615C0 1.76456 0.0263563 1.68631 0.073273 1.6286L1.32458 0.0900911C1.37151 0.0324058 1.43515 0 1.50151 0C1.56787 0 1.63151 0.0324058 1.67845 0.0900911L2.92975 1.6286C2.97534 1.68664 3.00056 1.76436 2.99999 1.84504C2.99942 1.92572 2.9731 2.0029 2.9267 2.05995C2.8803 2.117 2.81753 2.14936 2.75191 2.15006C2.6863 2.15076 2.62308 2.11974 2.57588 2.06369L1.50151 0.742728L0.427142 2.06369C0.380211 2.12138 0.316567 2.15379 0.250207 2.15379C0.183847 2.15379 0.120204 2.12138 0.073273 2.06369Z",
    fill: "#F76659"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevrondoublearrowup);
export default __webpack_public_path__ + "static/media/Chevron double arrow up.d510bc2d29f99b6c85876646a4fa1a6a.svg";
export { ForwardRef as ReactComponent };